import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { projectsApi } from 'src/Services/API';
import { editProjectCommentsCache } from 'src/Services/API/cache';
import { CreateCommentDto, CommentDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export type CreateProjectCommentVariables = CreateCommentDto & {
  projectId: string;
  assetId: string;
};

export const useCreateProjectComment = (
  options?: UseMutationOptions<CommentDto, unknown, CreateProjectCommentVariables>
) => {
  const queryClient = useQueryClient();

  return useMutation<CommentDto, unknown, CreateProjectCommentVariables>(
    'create-project-comment',
    async (data: CreateProjectCommentVariables) => {
      const response = await projectsApi.projectsControllerCreateComment(
        data.projectId,
        data.assetId,
        data
      );

      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        trackEvent('Project', 'comment');
        editProjectCommentsCache(queryClient, variables.projectId, undefined, data);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
